/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GradientIcon = ({ width = 24, height = 24, hidden = false, title = 'Gradient' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path opacity=".9" d="M4 6h2v24H4z" />
    <path opacity=".8" d="M6 6h2v24H6z" />
    <path opacity=".7" d="M8 6h2v24H8z" />
    <path opacity=".6" d="M10 6h2v24h-2z" />
    <path opacity=".5" d="M12 6h2v24h-2z" />
    <path opacity=".4" d="M14 6h2v24h-2z" />
    <path opacity=".25" d="M20 6h2v24h-2z" />
    <path opacity=".3" d="M18 6h2v24h-2z" />
    <path opacity=".35" d="M16 6h2v24h-2z" />
    <path opacity=".2" d="M22 6h2v24h-2z" />
    <path opacity=".15" d="M24 6h2v24h-2z" />
    <path opacity=".1" d="M26 6h2v24h-2z" />
    <path opacity=".05" d="M28 6h2v24h-2z" />
    <path
      d="M2 5v26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1Zm30 25H4V6h28Z"
    />
  </svg>`;
};
